import React from "react";
import { translate } from "../Services/translation";

const ItemScrollPromo = ({ item, index }) => (
    <div
        className={
            item.isActive ? "variant__item promo__active" : "variant__item"
        }
        key={index}
    >
        <a href={item.url}>
            {item.campaignTag && item.campaignTag.isActive &&
                <div className="campaign-tag variant-selection" style={{ backgroundColor: item.campaignTag.backgroundColor, width: item.campaignTag.tagSize, boxShadow: item.campaignTag.shadow}}>
                    <div className="campaign-tag__text" style={{ color: item.campaignTag.textColor}} dangerouslySetInnerHTML={{__html: item.campaignTag.text}}>
                    </div>
                </div>
            }
            {item.imageHtml ? (
                <div dangerouslySetInnerHTML={{ __html: item.imageHtml }}></div>
            ) : (
                <span className="product__image--missing">
                    {translate("product.noproductimage")}
                </span>
            )}
        </a>
        <div className="variant__container">
            <div>
                <span>{item.title}</span>
            </div>
        </div>
    </div>
);
export default ItemScrollPromo;
